export const AGENT_CREATED_SUCCESS_MESSAGE = "Agent created successfully.";

export function getAgentCreatedDetailState(agentId: string) {
  return {
    agentCreated: true,
    agentId: String(agentId),
  };
}

export function getHighlightedAgentsPath(agentId: string) {
  return `/agents?highlightAgentId=${encodeURIComponent(String(agentId))}`;
}
